import * as c from "react";
import { useRef as n } from "react";
import f from "../../../depend/rc-util/lib/raf.mjs";
function h(a) {
  const [l, o] = c.useState(a), e = n(null), r = n([]), t = n(!1);
  c.useEffect(() => (t.current = !1, () => {
    t.current = !0, f.cancel(e.current), e.current = null;
  }), []);
  function s(m) {
    t.current || (e.current === null && (r.current = [], e.current = f(() => {
      e.current = null, o((i) => {
        let u = i;
        for (const p of r.current)
          u = p(u);
        return u;
      });
    })), r.current.push(m));
  }
  return [l, s];
}
export {
  h as default
};
//# sourceMappingURL=useFrameState.mjs.map
